import { Schema, validateForm } from "./schemaClass";

export const blogSchema = validateForm({
  title: new Schema().required().minLength(10).maxLength(200),
  authorFirstName: new Schema().maxLength(30),
  authorLastName: new Schema().maxLength(30),
  contentData: new Schema().required(),
});

export const socialLinkSchema = validateForm({
  name: new Schema().required().onlyString().maxLength(30),
  url: new Schema().required().url(),
  icon: new Schema().required(),
});

export const FAQSchema = validateForm({
  question: new Schema().required(),
  answer: new Schema().required(),
});

export const AnouncementSchema = validateForm({
  title: new Schema().required(),
  description: new Schema().required(),
});

export const commentSchema = validateForm({
  text: new Schema().required(),
});

export const InstituteFormSchema = validateForm({
  "Institute Name": new Schema().required("Institute name is required"),
  "Institute Type": new Schema().required("Institute type is required"),
  phone: new Schema()
    .required("Phone number is required")
    .minLength(11, "Phone number must be at least 10 digits long")
    .maxLength(15, "Phone number must not exceed 15 digits"),
  email: new Schema()
    .required("Email is required")
    .email("Invalid email format"),
  password: new Schema().required("Password is required").minLength(8, "Password must be at least 8 characters long"),
  confirmPassword: new Schema().required("Please confirm your password")
});

export const InstituteCreateSchema = validateForm({
  InstituteName: new Schema().required("Institute name is required"),
  InstituteType: new Schema().required("Institute type is required"),
  phone: new Schema()
    .required("Phone number is required")
    .minLength(11, "Phone number must be at least 10 digits long")
    .maxLength(15, "Phone number must not exceed 15 digits"),
  email: new Schema()
    .required("Email is required")
    .email("Invalid email format"),
});

export const InstituteCreateSchemaConferance = validateForm({
  InstituteName: new Schema().required("Institute name is required"),
  InstituteType: new Schema().required("Institute type is required"),
  firstName: new Schema().required("First name is required"),
  lastName: new Schema().required("Last name is required"),
  phone: new Schema()
    .required("Phone number is required"),
  email: new Schema()
    .required("Institute email is required")
    .email("Invalid email format"),
  InstituteAddress: new Schema().required("Institute address is required"),
});

export const PlanSchema = validateForm({
  name: new Schema().required(),
  pricePerQty: new Schema().required().positiveNumber(),
  minimumQty: new Schema().required().positiveNumber().integerOnly(),
  frequency: new Schema().required(),
  planType: new Schema().required(),
});

export const instituteAddPlanSchema = validateForm({
  instituteName: new Schema().required(),
  planId: new Schema().required(),
  duration: new Schema().required().positiveNumber().integerOnly(),
  quantity: new Schema().required().positiveNumber().integerOnly(),
});

export const instituteProfessorSchema = validateForm({
  fname: new Schema().required("First name is required"),
  lname: new Schema().required("Last name is required"),
  totalQuantity: new Schema().required("Quantity is required").positiveNumber().integerOnly(),
  phone: new Schema()
    .required("Phone number is required")
    .minLength(11, "Phone number must be at least 10 digits long")
    .maxLength(15, "Phone number must not exceed 15 digits"),
  email: new Schema()
    .required("Email is required")
    .email("Invalid email format"),
});

export const professorChildSchema = validateForm({
  firstName: new Schema().onlyString().required("First name is required").minLength(3, "First name must be at least 3 characters long").maxLength(30, "First name can't be greater then 10 characters"),
  lastName: new Schema().onlyString().required("Last name is required").minLength(3, "Last name must be at least 3 characters long").maxLength(30, "Last name can't be greater then 10 characters"),
  password: new Schema().required("Password is required").minLength(8, "Password must be at least 8 characters long"),
  studentId: new Schema().integerOnly().positiveNumber().required("Student id is required").minLength(3, "Student id must be at least 3 numbers long"),
});